<template>
  <div class="widget-preview-message">
    <div
      class="widget-item"
      :class="isViewMessage ? 'item-message' : 'item'"
      v-for="(post, index) of posts"
      :key="index"
    >
      <widget-preview-item :post="post" :isViewMessage="isViewMessage" :snsType="snsType"></widget-preview-item>
    </div>
  </div>
</template>

<script lang="ts">
import Macy from 'macy'
import { defineComponent, PropType } from 'vue'

import WidgetPreviewItem from '@/client/components/_atoms/widget_preview_item'

type MacyInstance = {
  runOnImageLoad: (callback: () => void, everyLoad: boolean) => void
  recalculate: (refresh: boolean) => void
}

export default defineComponent({
  components: {
    WidgetPreviewItem
  },
  props: {
    posts: Array as PropType<Record<string, any>[]>,
    isViewMessage: Boolean,
    snsType: String,
    displayCount: Number
  },
  data() {
    return {
      macyInstance: null as MacyInstance | null
    }
  },
  updated() {
    // updated は mounted の後にしか呼ばれないので、macyInstance は作成済み
    const macyInstance = this.macyInstance
    macyInstance?.runOnImageLoad(() => {
      macyInstance.recalculate(true)
    }, true)
  },
  mounted() {
    this.macyInstance = Macy({
      container: '.widget-preview-message',
      trueOrder: true,
      waitForImages: true,
      columns: 4,
      margin: {
        x: 8,
        y: 8
      },
      breakAt: {
        '768': 2
      }
    })
  }
})
</script>

<style lang="scss" scoped>
@media only screen and (max-device-width: 480px) {
  .item {
    width: 100%;
    break-inside: avoid-column;
  }

  .grid-list-message {
    column-count: 2;
  }

  .grid-list {
    column-count: 2;
    column-gap: 0;
  }
}
</style>
